import React, {Component} from "react";

import LeaderboardRow from "./leaderboard-row.js";
class LeaderboardTable extends Component {
    
    render() {
        const {leaderboard_data} = this.props;
        return (
            <table className='leaderboard_table'>
                <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Score</th>
                </tr>
                {
                    leaderboard_data && leaderboard_data.map(function (player) {
                        return <LeaderboardRow player_data={player}></LeaderboardRow>
                    })
                }
            </table>
        );
    }
}

export default LeaderboardTable;


// WEBPACK FOOTER //
// ./src/components/containers/leaderboard/leaderboard-table.js